var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7708 1.08194C8.24682 0.696644 11.7548 0.696644 15.2308 1.08194C17.1298 1.29394 18.6608 2.78894 18.8838 4.69494C19.296 8.2196 19.296 11.7803 18.8838 15.3049C18.6608 17.2109 17.1298 18.7059 15.2318 18.9189C11.7554 19.3043 8.24715 19.3043 4.7708 18.9189C2.8718 18.7059 1.3408 17.2109 1.1178 15.3059C0.705526 11.781 0.705526 8.21993 1.1178 4.69494C1.3408 2.78894 2.8718 1.29394 4.7708 1.08194ZM15.0008 3.99994C14.7356 3.99994 14.4812 4.1053 14.2937 4.29284C14.1062 4.48037 14.0008 4.73473 14.0008 4.99994C14.0008 5.26516 14.1062 5.51951 14.2937 5.70705C14.4812 5.89459 14.7356 5.99994 15.0008 5.99994C15.266 5.99994 15.5204 5.89459 15.7079 5.70705C15.8954 5.51951 16.0008 5.26516 16.0008 4.99994C16.0008 4.73473 15.8954 4.48037 15.7079 4.29284C15.5204 4.1053 15.266 3.99994 15.0008 3.99994ZM5.2508 9.99994C5.2508 8.74017 5.75124 7.53198 6.64204 6.64119C7.53284 5.75039 8.74102 5.24994 10.0008 5.24994C11.2606 5.24994 12.4688 5.75039 13.3596 6.64119C14.2504 7.53198 14.7508 8.74017 14.7508 9.99994C14.7508 11.2597 14.2504 12.4679 13.3596 13.3587C12.4688 14.2495 11.2606 14.7499 10.0008 14.7499C8.74102 14.7499 7.53284 14.2495 6.64204 13.3587C5.75124 12.4679 5.2508 11.2597 5.2508 9.99994Z",
    fill: "#395BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.04c31a1a68cb67736721d1fb95c32e8d.svg";
export { ForwardRef as ReactComponent };